<p-progressBar *ngIf="showLoader" mode="indeterminate"></p-progressBar>
